export default class HelperProject{

    static serializeServicesToSelect(arr) {
        return arr.map(item => ({
            id: item.ID,
            text: item.title
        }));
    }

    static getSelectServiceTerms() {
        return Object.values(ESR.services_terms).map(item => ({
            id: item.term_id,
            text: item.term_name
        }));
    }

    static getServicesByTermID(termId) {
        return Object.values(ESR.services).filter(item => item.term_id === termId);
    }

    static getServiceByID(ID) {
        return ESR.services[ID];
    }

    static getServiceUnit(service) {
        const unit_key = service.unit;

        return unit_key;
    }

    static createRepeaterWorkItem(termId) {
        var $workItem = $('<div>', {class: 'esr-work-item'});
        var $row_1 = $('<div>', {class: 'esr-work-item-row-1'});
        var $row_2 = $('<div>', {class: 'esr-work-item-row-2'});

        //Row 1
        const elSelect = $('<select name="work[]" class="_select_work"><option></option></select>')

        var $workField = $('<label>', {class: 'form-control form-control-work'})
            .append('<div class="label"><span class="label-text">Lucrare</span></div>')
            .append(elSelect)

        const selectData = HelperProject.serializeServicesToSelect(HelperProject.getServicesByTermID(termId))

        elSelect.select2({
            language: "ro",
            placeholder: "Selectează",
            allowClear: true,
            data: selectData
        });

        var $volumeField = $('<label>', {class: 'form-control form-control-vol'})
            .append('<div class="label"><span class="label-text">Volum</span><span class="label-text-alt unit"></span></div>')
            .append(
                $('<div>', {class: 'esr-field__input'}).append('<input name="qty[]" type="number" class="input input-bordered">')
            );

        var $removeItem = $('<button class="btn btn-square btn-outline btn-primary _remove_work_item"><i class="esr-icon-remove" title="Șterge lucrare"></i></button>');

        $row_1.append(`<input name="category[]" type="hidden" value="${termId}">`).append($workField);
        $row_1.append($volumeField);
        $row_1.append($removeItem);

        //Row 2
        var $DescriptionField = $('<label>', {class: 'form-control form-control-work'})
            .append('<div class="label"><span class="label-text">Comentarii</span></div>')
            .append(`<textarea class="textarea border border-base-300" name="comment[]" placeholder="Comentarii"></textarea>`)

        $row_2.append($DescriptionField);

        return $workItem.append($row_1).append($row_2);
    }

    static createRepeaterItem(store) {
        var $repeaterItem = $('<div>', {class: 'esr-repeater-item'});

        const elSelect = $('<select class="_select_category"><option></option></select>')

        var $fieldCategory = $('<label>', {class: 'esr-field-category form-control'})
            .append($('<div class="label"><span class="label-text">Capitol</span></div>'))
            .append(elSelect);

        $repeaterItem.append($fieldCategory);

        var $buttons = $('<div>', {class: 'esr-works-actions'})
            .append('<button class="btn btn-primary _add_work_item"><i class="esr-icon-add"></i> Adaugă Lucrare</button>')
            .append('<button class="btn btn-outline btn-primary _remove_repeater_item">Șterge capitol</button>');

        var $works = $('<div>', {class: 'esr-works'})
            .append('<div class="esr-works-items"></div>')
            .append($buttons)

        $repeaterItem.append($works);

        elSelect.select2({
            language: "ro",
            placeholder: "Selectează",
            allowClear: true,
            data: store.service_categories
        });

        return $repeaterItem;
    }

}

